import { ExportOutlined } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';

const TaggedExportButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton {...props} icon={<ExportOutlined />} type="primary" />
  );
};

export default TaggedExportButton;
